import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Briefcase, Plus } from "lucide-react";

const blank = () => ({ name: "", phone: "", password: `Job@${Math.floor(1000 + Math.random() * 9000)}` });

export const MemberCandidates = () => {
  const [list, setList] = useState([]);
  const [f, setF] = useState(blank());
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/member/candidates").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const add = async () => {
    setBusy(true);
    try {
      await api.post("/member/candidates", f);
      toast.success(`Job candidate added — login: ${f.phone} / ${f.password}`);
      setF(blank()); load();
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="member-candidates">
      <p className="eyebrow text-gold mb-3 flex items-center gap-2"><Briefcase className="w-4 h-4" /> My job candidates</p>
      <Card className="p-4 bg-card/40 border-border/60 mb-3">
        <div className="grid sm:grid-cols-3 gap-2">
          <Input data-testid="mc-name" placeholder="Candidate name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="bg-card/60" />
          <Input data-testid="mc-phone" placeholder="+9198XXXXXXXX" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="bg-card/60" />
          <Input data-testid="mc-password" placeholder="Password (min 6)" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="bg-card/60" />
        </div>
        <Button data-testid="mc-add-btn" onClick={add} disabled={busy} className="w-full mt-3 bg-gold text-[#0a2e22] hover:bg-gold/90 font-semibold gap-1.5"><Plus className="w-4 h-4" /> Add job candidate</Button>
        <p className="text-[11px] text-muted-foreground mt-2">The candidate logs in at Customer Login with this mobile + password to upload CV and apply for jobs.</p>
      </Card>
      <div className="space-y-2">
        {list.map((c) => (
          <Card key={c.id} data-testid={`mc-row-${c.id}`} className="p-3 bg-card/40 border-border/60 flex items-center justify-between">
            <div><p className="text-sm font-medium">{c.name}</p><p className="text-[11px] text-muted-foreground font-mono">{c.phone}</p></div>
            <span className="text-[11px] text-muted-foreground">{new Date(c.created_at).toLocaleDateString("en-IN")}</span>
          </Card>
        ))}
        {list.length === 0 && <p className="text-xs text-muted-foreground text-center py-4">No job candidates yet.</p>}
      </div>
    </div>
  );
};
